module.exports = __webpack_public_path__ + "img/Group 8944.aaddc267.svg";